import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit
} from "@fortawesome/free-solid-svg-icons";
import Shimmer from '../../../../../components/Custom/Loading/Shimmer';

const StepOne = ({ departments, handleDepartmentChange, taskDetails, currentStep, handlePreviousStep, loading }) => {
    const handleChange = (e) => {
        const { value } = e.target;
        handleDepartmentChange(value);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="card shadow mb-4 col-lg-5 mx-auto position-relative"
        >

            <div className="card-body text-center">
                <h4 className="text-center">Let's get you started with creating a Task.</h4>
                <div className="form-group">
                    <label className="text-center">Please choose a department</label>
                    <select
                        className="form-control"
                        name="departmentID"
                        value={taskDetails.departmentID || ''}
                        onChange={handleChange}
                        disabled={currentStep !== 1}
                    >
                        <option value="">Please choose a department</option>
                        {departments.map(department => (
                            <option key={department.departmentID} value={department.departmentID}>
                                {department.name}
                            </option>
                        ))}
                    </select>
                </div>
                {currentStep > 1 && (
                    <button className="btn btn-secondary btn-sm mt-3" onClick={handlePreviousStep}><FontAwesomeIcon icon={faEdit} /> Edit</button>
                )}
            </div>
            {loading && <Shimmer type="list" />}
        </motion.div>
    );
};

export default StepOne;
